function get(id, filtros) {
  return filtros.find((f) => f.id === id);
}

function getHabilitado(filtroBase) {
  return Object.keys(filtroBase).reduce((acumulador, prop) => {
    if (filtroBase[prop].habilitado) {
      acumulador = true;
    }
    return acumulador;
  }, false);
}

function getVisualizacaoOpcao(opcao) {
  switch (typeof opcao) {
    case 'boolean':
      return opcao ? 'Sim' : 'Não';
    case 'object':
      return opcao && opcao.nome ? opcao.nome : '';
    default:
      return opcao;
  }
}

function verificaOutros(filtro, visualizacao) {
  const filtroOutros = get('outros', filtro.filhos);
  if (filtroOutros && filtroOutros.outros) {
    const visualizacaoOutros = `${filtroOutros.titulo} (${filtroOutros.outros})`;
    if (visualizacao.trim() === '') {
      return visualizacaoOutros;
    }
    return `${visualizacao}, ${visualizacaoOutros}`;
  }
  return visualizacao;
}

function verificaOutrosHabilitado(filtro, habilitado) {
  const filtroOutros = get('outros', filtro.filhos);
  const outrosHabilitado = habilitado
    || (filtroOutros && filtroOutros.opcao && filtroOutros.outros !== null && filtroOutros.outros !== '');
  return Boolean(outrosHabilitado);
}

function getRetorno(filtro) {
  let visualizacao = '';
  let habilitado = false;
  switch (filtro.tipo) {
    case 'unidade':
      visualizacao = filtro.unidades.map((u) => u.sigla).join(', ');
      habilitado = filtro.habilitado && filtro.unidades.length > 0;
      return {
        selecionado: filtro.unidades,
        macro: filtro.macro,
        tituloVisualizacao: 'Unidades',
        visualizacao: verificaOutros(filtro, visualizacao),
        habilitado: verificaOutrosHabilitado(filtro, habilitado),
      };
    case 'select':
      visualizacao = filtro.selecionado.map((i) => i.nome).join(', ');
      habilitado = filtro.habilitado && filtro.selecionado.length > 0;
      return {
        selecionado: filtro.selecionado,
        tituloVisualizacao: filtro.titulo,
        visualizacao: verificaOutros(filtro, visualizacao),
        habilitado: verificaOutrosHabilitado(filtro, habilitado),
      };
    case 'confirm':
      visualizacao = getVisualizacaoOpcao(filtro.opcao);
      habilitado = filtro.habilitado && filtro.opcao !== null;
      return {
        opcao: filtro.opcao,
        tituloVisualizacao: filtro.titulo,
        visualizacao: verificaOutros(filtro, visualizacao),
        habilitado: verificaOutrosHabilitado(filtro, habilitado),
      };
    case 'time':
      if (!filtro.anos && !filtro.meses) {
        visualizacao = '';
      } else {
        const anos = parseInt(filtro.anos, 10);
        let strAnos = '';
        if (anos > 1) {
          strAnos = `${anos} anos`;
        } else if (anos === 1) {
          strAnos = '1 ano';
        }
        const meses = parseInt(filtro.meses, 10);
        let strMeses = '';
        if (meses > 1) {
          strMeses = `${meses} meses`;
        } else if (meses === 1) {
          strMeses = '1 mês';
        }

        if (strAnos && strMeses) {
          visualizacao = `${strAnos} e ${strMeses}`;
        } else {
          visualizacao = `${strAnos}${strMeses}`;
        }
      }
      return {
        anos: filtro.anos,
        meses: filtro.meses,
        tituloVisualizacao: filtro.titulo,
        visualizacao,
        habilitado: filtro.habilitado && (filtro.anos > 0 || filtro.meses > 0),
      };
    case 'extra':
      return {
        opcao: filtro.opcao,
        outros: filtro.outros,
        tituloVisualizacao: filtro.titulo,
        visualizacao: filtro.opcao ? filtro.opcao : '',
        habilitado: Boolean(filtro.opcao && filtro.outros),
      };
    default:
      return null;
  }
}

export default { get, getRetorno, getHabilitado };
